var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isLangEn ? 'app-layout-type-en' : 'app-layout-type-zh',attrs:{"id":"app"}},[_c('router-view'),_c('GlobalLayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }